export const blue = `rgba(32, 41, 68, 1)`;
export const deepBlue = `rgba(20, 25, 40, 1)`;
export const fontColor = ` rgba(231, 221, 30, 1)`;
export const activeMenuColor = `rgba(20,24,39,1)`;
export const borderColor = `gray`;
export const grayBorder = `border: solid 1px gray;`;
export const whiteFont = `white`;
export const lightBlue = `rgba(50,60,86,1)`;
export const grayFont = `color:gray`;
